export class NotificationPolicyConfigSlack {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "channel",
            "baseName": "channel",
            "type": "string",
            "format": ""
        },
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfigSlack.attributeTypeMap;
    }
    constructor() {
    }
}
